import React from 'react';

export function EmployeeList () {

    return (    
      <section className="content">
  
        <div className="box box-default">
          <div className="box-header with-border">
            
  
            <div className="box-header">
                <div className="col-sm-6">
                    <div className="form-group">                        
                        <select className="form-control">
                          <option>綠活人力資源</option>
                          <option>綠映人力資源</option>
                          <option>option 3</option>
                          <option>option 4</option>
                          <option>option 5</option>
                        </select>
                    </div>
                </div>
            
           
            </div>
          <hr style={{height: "1px", padding:"0", margin:"0"}} />
              <div className="box-header">
                  <div className="col-sm-5" style={{marginTop: "5px"}}>
                      <div className="row">
                          <div className="col-sm-5">
                              <a href="#A">在職員工 <span className="badge bg-green">12</span></a>
                          </div>
                          <div className="col-sm-5">
                          <a href="#A">離職員工 <span className="badge bg-red">842</span></a>
                          </div>
                      </div>
                  </div>
            
            
                      <div className="col-sm-2">
                          <button type="button" className="btn btn-block btn-info btn-sm"><i className="fa fa-plus"></i> 新增帳號</button>
                      </div>
            
                      <div className="col-sm-2">
                          <button type="button" className="btn btn-block btn-info btn-sm"><i className="fa fa-hand-o-right"></i> 指定職位</button>
                      </div>
            
        
                      <div className="box-tools" style={{marginTop: "5px"}}>
                        <div className="input-group input-group-sm" style={{width: "150px"}}>
                          <input type="text" name="table_search" className="form-control pull-right" placeholder="Search" />
        
                          <div className="input-group-btn">
                            <button type="submit" className="btn btn-default"><i className="fa fa-search"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                
              </div>


              <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <tbody><tr>
                    <th width="20%">姓名</th>
                    <th width="10%">部門</th>
                    <th width="10%">職稱</th>
                    <th width="10%">性別</th>
                    <th width="30%">手機</th>
                    <th width="10%">狀態</th>
                  </tr>
                  <tr>
                    <td>王大同</td>
                    <td>人資部</td>
                    <td>主管</td>
                    <td>男</td>
                    <td>0988123456</td>
                    <td><span className="label label-success">在職</span></td>
                  </tr>
                  <tr>
                      <td>王大同</td>
                      <td>人資部</td>
                      <td>主管</td>
                      <td>男</td>
                      <td>0988123456</td>
                      <td><span className="label label-success">在職</span></td>
                    </tr>
  
                    <tr>
                        <td>王大同</td>
                        <td>人資部</td>
                        <td>主管</td>
                        <td>男</td>
                        <td>0988123456</td>
                        <td><span className="label label-success">在職</span></td>
                      </tr>
                      
                    <tr>
                          <td>王大同</td>
                          <td>人資部</td>
                          <td>主管</td>
                          <td>男</td>
                          <td>0988123456</td>
                          <td><span className="label label-danger">離職</span></td>
                     </tr> 
                  
                </tbody></table>
              </div>
              <div className="box-footer clearfix">
                  <ul className="pagination pagination-sm no-margin pull-right">
                    <li><a href="#A">«</a></li>
                    <li><a href="#A">1</a></li>
                    <li><a href="#A">2</a></li>
                    <li><a href="#A">3</a></li>
                    <li><a href="#A">»</a></li>
                  </ul>
                </div>
            </div>
        <div className="box box-default">
            <div className="box-header with-border">
                <h3 className="box-title">注意事項</h3>
                <div className="box-tools pull-right">
                    <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
                  </div>
              </div>
  
              <div className="box-body">
                  <ol>
                    <li>有新進員工，請先新增帳號，再指定員工...</li>
                    <ol>
                        <li>Phasellus iaculis neque</li>
                        <li>Purus sodales ultricies</li>
                        <li>Vestibulum laoreet porttitor sem</li>
                        <li>Ac tristique libero volutpat at</li>
                      </ol>
                    <li>員工離職時....</li>
                    <li>職務調動時.....</li>
                      <ol>
                        <li>Phasellus iaculis neque</li>
                        <li>Purus sodales ultricies</li>
                        <li>Vestibulum laoreet porttitor sem</li>
                        <li>Ac tristique libero volutpat at</li>
                      </ol>
                  </ol>
                </div>
            </div>
  
        
      </section>
    )
}